import styled from 'styled-components'
import theme from '../../styles/theme'

export const FormWrapper = styled.div`
  border: ${theme.borderDefault};
  padding: 16px;
`

export const TitleBox = styled.h4`
  margin: 0px;
  line-height: 2.95rem;
  padding: 0 1.2rem;
  font-size: ${theme.headingCheckout};
  font-family: ${theme.brandFontFamily};
  font-weight: 400;
  text-align: center;
  border-top: ${theme.borderDefault};
  border-left: ${theme.borderDefault};
  border-right: ${theme.borderDefault};
`
